import Portfolio from "../components/sections/Portfolio";
import Testimonials from "../components/sections/Testimonials";
import { motion } from "framer-motion";
import useSEO from "../lib/useSEO";

export default function PortfolioPage() {
    useSEO({
        title: "Work & Portfolio — Retail ERP, Logistics, Finance Apps | Thooyra Technologies",
        description:
            "Selected projects by Thooyra Technologies: retail ERP, logistics dashboard, finance analytics, mobile billing, cloud migration, AI assistants and restaurant management systems.",
        path: "/portfolio",
    });
    return (
        <main data-testid="portfolio-page">
            <section className="relative pt-36 pb-12 md:pt-44 md:pb-16 overflow-hidden">
                <div
                    aria-hidden
                    className="absolute inset-0 -z-10 pointer-events-none"
                >
                    <div className="absolute top-10 left-1/3 w-[420px] h-[420px] rounded-full bg-teal-200/30 dark:bg-teal-500/10 blur-[120px] animate-blob" />
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <motion.div
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            Work
                        </div>
                        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                            Real software for{" "}
                            <span className="italic font-medium">
                                real teams
                            </span>
                            .
                        </h1>
                        <p className="mt-8 max-w-2xl text-muted-foreground text-lg leading-relaxed">
                            A glimpse into the platforms, dashboards and apps
                            we&apos;ve helped bring to life.
                        </p>
                    </motion.div>
                </div>
            </section>
            <Portfolio />
            <Testimonials />
        </main>
    );
}
